import { makeStyles } from '@material-ui/styles'
import {
    AccountBalanceWalletOutlined,
    FaceRounded, HistoryRounded,
    InventoryRounded, ListRounded, MoneyRounded,
    PaidOutlined, SettingsRounded,
    SpeedRounded
} from '@mui/icons-material'
import { Box, ButtonBase, Stack, styled, Typography } from '@mui/material'
import grey from '@mui/material/colors/grey'
// import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { selectSideMenuState } from '../../../store/features/app'
import { selectCurrrentAdminShop } from '../../../store/features/currentBusinessShop'
import Accordion from '../../molecules/Accordion'
import List from '../../molecules/List'


interface ICustomBoxProps{
    path: string
}

export default function DashboardMenu() {

    const sideMenuState = useSelector(selectSideMenuState)
    
    return (
        <Box
            sx={{
                overflowY: "auto",
                height: "100%"
            }}
        >
            {
                sideMenuState === "full" ? <FullSideMenu /> : <ShrinkedSideMenu />
            }
            
        </Box>
    )
}

function FullSideMenu(){
    
    const {push} = useHistory()
    const {pathname} = useLocation()
    const currentShop = useSelector(selectCurrrentAdminShop)
   


    const CustomBox = styled(Box)<ICustomBoxProps>(({theme, path})=>`
        background-color: ${path ===pathname ? theme.palette.primary.dark : theme.palette.primary.main};
        :hover:{
            background-color: ${theme.palette.primary.dark},
            transition: "0.3s",
            cursor: "pointer"
        }
    `);

    return(

        <>
            {
                currentShop ? (
                    <>
                        <CustomBox
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: "row",
                                alignItems: "center",
                                padding: "1rem",
                                boxShadow: "none",
                                backgroundColor: pathname === `/${currentShop.name}` ? 'primary.dark' : 'primary.main'
                            }}
                            onClick={()=>push(`/${currentShop.name}`)}
                            path={`/${currentShop.name}`}
                        >
                            <SpeedRounded sx={styles.icon} /> <Typography sx={styles.typography} >Dashboard</Typography>
                        </CustomBox>
                        {/* <CustomBox
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: "row",
                                alignItems: "center",
                                padding: "1rem",
                                boxShadow: "none",
                                borderTop: '.1px solid rgba(255, 255, 255, 0.1)',
                                backgroundColor: pathname === `/${currentShop.name}/sales` ? 'primary.dark' : 'primary.main'
                            }}
                            onClick={()=>push(`/${currentShop.name}/sales`)}
                            path={`/${currentShop.name}/sales`}
                        >
                            <CustomMenuLink to="/sales">
                                <PaidOutlined sx={styles.icon} /> <Typography sx={styles.typography} >Sales</Typography>
                            </CustomMenuLink>
                        </CustomBox> */}
                        <Accordion
                            data={[
                                {
                                    Icon: <PaidOutlined sx={styles.icon} />,
                                    title: "Sales",
                                    route: `/${currentShop.name}/sales`,
                                    content: <List items={[
                                        {
                                            text: "Cold room",
                                            onClick: ()=>push(`/${currentShop.name}/sales:cold_room`)
                                        },
                                        {
                                            text: "Freezer 1",
                                            onClick: ()=>push(`/${currentShop.name}/sales:freezer_1`)
                                        },
                                        {
                                            text: "Freezer 2",
                                            onClick: ()=>push(`/${currentShop.name}/sales:freezer_2`)
                                        },
                                    ]} />
                                },
                                {
                                    Icon: <InventoryRounded sx={styles.icon} />,
                                    title: "Inventory",
                                    route: `/${currentShop.name}/inventory`,
                                    content: <List items={[
                                        {
                                            text: "Cold room",
                                            onClick: ()=>push(`/${currentShop.name}/inventory:cold_room`)
                                        },
                                        {
                                            text: "Freezer 1",
                                            onClick: ()=>push(`/${currentShop.name}/inventory:freezer_1`)
                                        },
                                        {
                                            text: "Freezer 2",
                                            onClick: ()=>push(`/${currentShop.name}/inventory:freezer_2`)
                                        },
                                    ]} />
                                },
                                {
                                    Icon: <MoneyRounded sx={styles.icon} />,
                                    title: "Expenses",
                                    route: `/${currentShop.name}/expenses`,
                                    content: <List items={[
                                        {
                                            text: "View",
                                            onClick: ()=>push(`/${currentShop.name}/expenses`)
                                        },
                                        {
                                            text: "Export",
                                            onClick: ()=>{console.log("")}
                                        },
                                    ]} />
                                },
                                {
                                    Icon: <ListRounded sx={styles.icon} />,
                                    title: "Catalogs",
                                    content: <List items={[
                                    
                                        {
                                            text: "Brands",
                                            onClick: ()=>push(`/${currentShop.name}/brands`)
                                        },
                                        {
                                            text: "Categories",
                                            onClick: ()=>push(`/${currentShop.name}/categories`)
                                        },
                                        
                                    ]} />
                                },
                                {
                                    Icon: <FaceRounded sx={styles.icon} />,
                                    title: "Employees",
                                    content: <List items={[
                                        {
                                            text: "Add new",
                                            onClick: ()=>{console.log("")}
                                        },
                                        {
                                            text: "Current",
                                            onClick: ()=>push(`/${currentShop.name}/employees`)
                                        },
                                    ]} />
                                },
                                {
                                    Icon: <HistoryRounded sx={styles.icon} />,
                                    title: "Logs",
                                    content: <List items={[
                                        {
                                            text: "User",
                                            onClick: ()=>push(`/${currentShop.name}/user-logs`)
                                        },
                                        {
                                            text: "Sales",
                                            onClick: ()=>push(`/${currentShop.name}/sales-logs`)
                                        },
                                        {
                                            text: "Inventory",
                                            onClick: ()=>push(`/${currentShop.name}/inventory-logs`)
                                        },
                                    ]} />
                                },
                                {
                                    Icon: <AccountBalanceWalletOutlined sx={styles.icon} />,
                                    title: "Imprest System",
                                    content: <List items={[
                                        {
                                            text: "Allocate petty cash",
                                            onClick: ()=>(console.log("ne"))
                                        },
                                        {
                                            text: "New float",
                                            onClick: ()=>(console.log("ne"))
                                        },
                                        {
                                            text: "History",
                                            onClick: ()=>push(`/${currentShop.name}/impress`)
                                        },
                                    ]} />
                                },
                                {
                                    Icon: <SettingsRounded sx={styles.icon} />,
                                    title: "Settings",
                                    content: <List items={[
                                        {
                                            text: "Account settings",
                                            onClick: ()=>push(`/${currentShop.name}/account-settings`)
                                        },
                                        {
                                            text: "General settings",
                                            onClick: ()=>push(`/${currentShop.name}/general-settings`)
                                        },
                                    ]} />
                                },
                            ]} 
                        />
                    </>
                ) : (
                    <CustomBox
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flexDirection: "row",
                            alignItems: "center",
                            padding: "1rem",
                            boxShadow: "none",
                            backgroundColor: "primary.dark"
                        }}
                        onClick={()=>push('/')}
                        path='/'
                    >
                        <SpeedRounded sx={styles.icon} /> <Typography sx={styles.typography} >Admin portal</Typography>
                    </CustomBox>
                )
            }
        </>

    )

}

function ShrinkedSideMenu(){

    const classes = useStyles()
    const currentShop = useSelector(selectCurrrentAdminShop)

    return(

        <>
            {/* <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    alignItems: "center",
                    padding: "1rem",
                    boxShadow: "none",
                }}
            >
                <SpeedRounded sx={styles.icon} /> <Typography sx={styles.typography} >Dashboard</Typography>
            </Box> */}
            {
                currentShop ? (
                    <Stack
                        direction="column"
                        spacing={1}
                    >
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <SpeedRounded className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <PaidOutlined className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <MoneyRounded className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <InventoryRounded className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <ListRounded className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <FaceRounded className={classes.icon} />
                        </ButtonBase>
                        {/* <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <ReceiptLongRounded className={classes.icon} />
                        </ButtonBase> */}
                        
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <HistoryRounded className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <AccountBalanceWalletOutlined className={classes.icon} />
                        </ButtonBase>
                        
                        {/* <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <StoreRounded className={classes.icon} />
                        </ButtonBase>
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <PointOfSaleRounded className={classes.icon} />
                        </ButtonBase> */}
                        <ButtonBase
                            className={classes.iconWrapper}
                        >
                            <SettingsRounded className={classes.icon} />
                        </ButtonBase>
                    </Stack>
                ) : (
                    <Stack direction="column" spacing={1}>
                        <ButtonBase
                            className={classes.iconWrapper}
                            sx={{backgroundColor: "primary.dark"}}
                        >
                            <SpeedRounded className={classes.icon} />
                        </ButtonBase>
                    </Stack>
                )
            }

        </>

    )

}

const styles = {

    icon: {
        color: grey[200],
        fontSize: "16px",
        alignSelf: "center",
        justifySelf: "center",
        marginRight: "8px"
    },
    typography:{
        color:"grey.200",
        fontSize: "14px"
    }

}

const useStyles = makeStyles((theme)=>( {

    icon: {
        color: grey[200],
        fontSize: "18px",
        alignSelf: "center",
        justifySelf: "center",
        marginRight: "8px"
    },
    iconWrapper:{
        display: "flex",
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        padding: ".7rem 1.5rem",
        boxShadow: "none",
    },
    typography:{
        color:"grey.200",
        fontSize: "14px"
    }

}))